<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField
      :form="formInline"
      :formCtrl="formCtrl"
      @onSearch="onSearch"
      @onReset="onReset"
    >
      <template #start>
        <el-form-item class="startBtn">
          <el-button type="primary" @click="addItem" icon="el-icon-plus">添加</el-button>
        </el-form-item>
        <!-- 复合日期搜索框 -->
        <!-- <CompositeFormDate
          ref="comFormDate"
          :type="'daterange'"
          :options="searchDateOptions"
          @onChange="onComSearchChange"
        >
        </CompositeFormDate> -->
      </template>

      <template #beforeBtn>
        <!-- 复合日期搜索框 -->
        <CompositeFormDate
          ref="comFormDate"
          :type="'daterange'"
          :options="searchDateOptions"
          @onChange="onComSearchChange"
        >
        </CompositeFormDate>
      </template>
    </SearchField>

    <Table
      ref="table"
      :tableData="tableData"
      :cols="cols"
      :page="page"
      :limit="limit"
      :total="total"
      :showIndex="true"
      :btns="btns"
      @onSelectionChange="onSelectionChange"
      @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange"
    />
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: "carmaintenance",
      delUrl: "del",
      title: "添加",
      breadcrumb: [
        {
          name: "车辆管理",
        },
        {
          name: "车辆维护",
        },
      ],
      formInline: {},
      searchDateOptions: [
        { label: "维护日期", keyName: "maintenance_date" },
        { label: "到期日期", keyName: "expire_date" },
      ],
      viewMode: false,
      formCtrl: [
        {
          label: "车牌号",
          keyName: "license",
          placeholder: "请填写车牌号",
          type: "text",
        },
        {
          label: "维护类型",
          keyName: "maintenance_type",
          type: "select",
          err: "请选择维护类型",
          options: [
            {
              label: "一级维护",
              value: "一级维护",
            },
            {
              label: "二级维护",
              value: "二级维护",
            },
          ],
        },
        {
          label: "维护机构",
          keyName: "agency_id",
          err: "请选择维护机构",
          type: "select",
          options: [],
        },
      ],
      cols: [
        {
          prop: "license",
          label: "车牌号",
          minwidth: 120,
        },
        {
          prop: "driver",
          label: "司机姓名",
        },
        {
          prop: "maintenance_date",
          label: "维护日期",
        },
        {
          prop: "expire_date",
          label: "到期日期",
        },
        {
          prop: "maintenance_type",
          label: "维护类型",
        },
        {
          prop: "name",
          label: "维护机构",
        },
      ],
      btns: [
        {
          ...this.editBtn,
          cb: ({ id, car_id, driver_id }) => {
            this.$router.push(
              `/vehicle/maintainDetail?mode=edit&id=${id}&car_id=${car_id}&driver_id=${driver_id}`
            );
            // console.log(id);
          },
        },
        {
          ...this.delBtn,
          cb: ({ id }) => {
            this.delete(id);
          },
        },
      ],
    };
  },
  methods: {
    delParamsPackage(params) {
      params["headers"] = {
        "X-Method": "delete",
        "X-Module": "hire_car",
      };

      // console.log('params', { ...params })
    },

    addItem() {
      // const { car_id, driver_id } = this.$route.query;
      // this.$router.push(
      //   `/vehicle/maintainDetail?car_id=${car_id}&driver_id=${driver_id}`
      // );
      this.$router.push(`/vehicle/maintainDetail`);
    },

    setOptions({ agency_list }) {
      this.formCtrl.map((v) => {
        if (v.keyName == "agency_id" && agency_list && agency_list.length) {
          v.options = agency_list.map((val) => {
            return {
              label: val.name,
              value: val.id,
            };
          });
        }
      });
    },
  },
  mounted() {
    this.setQueryParams();
    this.$nextTick(this.getList);
    this.getOptions();
    // this.tabIdx = this.tabIdxMemo(this.$route.path) || 0
  },
};
</script>

<style lang="less" scoped>
/deep/ .dialog {
  .el-form {
    .el-input,
    .el-textarea {
      width: 230px;
    }
  }

  .btns .mians {
    text-align: center;
  }
}
</style>
